module.exports = __webpack_public_path__ + "static/divide-f720d51f0564d0225aba651992fc9a79.svg";